import { Component, HostListener } from '@angular/core';

@Component({
    selector: 'claims-root',
    templateUrl: './claims.component.html',
    styleUrls: ['./claims.component.scss']
})
export class ClaimsComponent {
    title = 'hlasenia-angular';

    // @HostListener('window:beforeunload', ['$event'])
    // handleUnload($event:BeforeUnloadEvent) {
    //     $event.preventDefault();
    // }

}
